var exports = {
  "Qs": "CustomStatusDisplay.module__content___NUM0cm",
  "pF": "CustomStatusDisplay.module__singleLine___NUM0cm",
  "tD": "CustomStatusDisplay.module__constrained___NUM0cm",
  "IY": "CustomStatusDisplay.module__truncatedText___NUM0cm",
  "j9": "CustomStatusDisplay.module__clamped___NUM0cm",
  "H0": "CustomStatusDisplay.module__statusEmoji___NUM0cm",
  "My": "CustomStatusDisplay.module__statusEmojiWrapper___NUM0cm",
  "hb": "CustomStatusDisplay.module__staticEmoji___NUM0cm",
  "oG": "CustomStatusDisplay.module__animatedEmoji___NUM0cm",
  "kK": "CustomStatusDisplay.module__hiddenVisually___NUM0cm",
  "SA": "CustomStatusDisplay.module__jumbo___NUM0cm",
  "We": "CustomStatusDisplay.module__editableWrapper___NUM0cm",
  "Ke": "CustomStatusDisplay.module__editableTextHover___NUM0cm",
  "BW": "CustomStatusDisplay.module__editPencilIcon___NUM0cm",
  "dX": "CustomStatusDisplay.module__editableEmojiOnly___NUM0cm",
  "qf": "CustomStatusDisplay.module__placeholder___NUM0cm",
  "Dm": "CustomStatusDisplay.module__placeholderIcon___NUM0cm",
  "RC": "CustomStatusDisplay.module__placeholderText___NUM0cm",
  "_C": "CustomStatusDisplay.module__emojiPressable___NUM0cm",
  "on": "CustomStatusDisplay.module__emojiTooltipTrigger___NUM0cm",
};

module.exports = exports;
